
<div>
    <c-column-header
        class="primary"
        label="Kunden"
    >
        <template v-slot:filter>
            <c-item-count :count="customers.length" />
        </template>
    </c-column-header>
    <div class="lm-border pa-3 mt-1 pb-3">
        <v-text-field
            v-model        = "search"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
            append-icon    = "fas fa-search"
            :clearable     = "true"
            @input         = "onSearch"
            dense
            hide-details
        />
    </div>
    <div class="mt-1 pt-1 mb-2 item-container">
        <v-list class="pt-1 lm-border mr-1">
            <v-list-item
                v-for   = "(customer,index) in customers"
                :key    = "index"
                :ripple = "false"
                @click  = "onCustomer(customer)"
                class   = "pr-1"
                :class  = "selected && selected.id === customer.id ? 'item-selected' : 'lightgray'"
                dense
            >
                <div class="item-text v-flex w-100" >
                    <div>
                        {{ customer.name}}
                    </div>
                </div>
            </v-list-item>
        </v-list>
    </div>
</div>
